import blog from "./blog";
import common from "./common";
import store from "./store";

export default {
  blog,
  common,
  store,
};
